/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { FlyInputEvent } from '@customerio/fly-components/types/fly-components/events';
import { InlineContractsSalesPageArgs } from 'cio/components/inline-contracts-sales';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';
import BillingService from 'cio/services/billing';
import { PlanType } from 'cio/models/plan';
import { currentOfferingsByPlanType } from 'cio/utils/billing/plans';

const GREETING = {
  legacy:
    "it looks like you're on an older plan and are interested in one of our newer plans! Great, we'd love to help you with that upgrade.",
  trials: "it looks like you're interested in purchasing a plan! Great, we'd love to help you with that.",
  upgradeDowngradeRequest:
    "it looks like you're interested in changing your plan! Great, we'd love to help you with that.",
  enterprise: "it looks like you're interested in upgrading your plan! Great, we'd love to help you with that.",
};

export default class BodyPage extends Component<InlineContractsSalesPageArgs> {
  @service account!: AccountService;
  @service billing!: BillingService;

  @action
  handleBodyInput(event: FlyInputEvent<HTMLTextAreaElement>) {
    let value = event.target?.value;
    this.args.setFormValue('message', value);
  }

  @action
  handleFeaturesInput(event: FlyInputEvent<HTMLTextAreaElement>) {
    let value = event.target?.value;
    this.args.setFormValue('features', value);
  }

  @action
  handleEmailInput(value: string) {
    this.args.setFormValue('replyTo', value);
  }

  get firstName() {
    return this.account.current?.currentUser?.firstName ?? 'there';
  }

  get welcomeMessage() {
    let { planClicked } = this.args;
    let trial = this.billing.billingInfo?.trial ?? false;
    let currentPlanType = this.billing.subscription?.plan.planType;

    if (trial) {
      return GREETING.trials;
    } else if (currentOfferingsByPlanType.includes(currentPlanType ?? PlanType.NotReportable)) {
      if (planClicked !== PlanType.Enterprise) {
        return GREETING.upgradeDowngradeRequest;
      } else {
        return GREETING.enterprise;
      }
    }
    return GREETING.legacy;
  }
}
